import { EventEmitter, Injectable, Output } from '@angular/core';
import API from '../../../modules/common/services/api.config.json';
import { map } from 'rxjs/operators';
import { ApiService } from '../../../modules/common/services/api.service';
import { Observable } from 'rxjs';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { Coordinacion } from '../entities/Coordinacion';
import { Doctor } from '../entities/Doctor';
import { DoctorSmi } from '../entities/doctot-smi';
import { DoctorVacations } from '../entities/doctor-vacations';
import { ExtraPeriod } from '../entities/extra-period';
import { DoctorConsulta } from '../entities/doctor-consulta';
import { DoctorTarifa } from '../entities/doctor-tarifa';
import { DocMedico } from '../entities/doctor-documentation';
import { Doctorschedule } from '../entities/doctor-schedule';
import { AgendaMed } from '../entities/agenda-med';
import { DoctorAgendaReport } from '../entities/doctor-agenda-report';

@Injectable({providedIn:'root'})
export class DoctorService {

    public Medico: any = [];
    public selectedDoctorId: number = 0;
    public doctorSmiList: DoctorSmi[];


    constructor(private apiService: ApiService) {
        this.selectedDoctorId = 0;
    }
    //LoadMedico
    GetActiveDoctors(): Observable<RestResponse> {
        const url = `${API.MedicoView.getActiveMedicos}`;
        return this.apiService.get(url);
    }

    GetActiveDUE(): Observable<RestResponse> {
        const url = `${API.MedicoView.getActiveDUE}`;
        return this.apiService.get(url);
    }

    GetActiveDoctorsDropdown(): Observable<any> {
        return this.GetActiveDoctors()
            .pipe(map(resp => {
                return resp.result.map(element => {
                    return { value: element.value, viewValue: element.viewValue };
                });
            }));
    }

    GetActiveDueDropdown(): Observable<any> {
        return this.GetActiveDUE()
            .pipe(map(resp => {
                return resp.result.map(element => {
                    return { value: element.value, viewValue: element.viewValue };
                });
            }));
    }

    GetDoctorServiceValidation(doctorId: string, companyId: string): Observable<RestResponse> {
        let url = `${API.Doctor.getServiceValidation}`;
        url = url.replace('{doctorId}', doctorId).replace('{companyId}', companyId);
        return this.apiService.get(url);
    }

    FilterSpecialist(searchText: string, empoloyeeId: string): Observable<RestResponse> {
        let url = `${API.Doctor.filterSpecialist}`;
        url = url.replace('{searchText}', searchText).replace('{employeeId}', empoloyeeId);
        return this.apiService.get(url)
            .pipe(map(res => {
                return res.result;
            }));
    }

    GetServicesByCompanyAndDoctor(doctorId: string, companyId: string): Observable<RestResponse> {
        let url = `${API.MedicoView.getSmeByDoctorAndCompany}`;
        url = url.replace('{doctorId}', doctorId).replace('{companyId}', companyId);
        return this.apiService.get(url);
    }

    GetDoctor(doctorId: string): Observable<RestResponse> {
        let url = `${API.Doctor.getDoctor}`;
        url = url.replace('{doctorId}', doctorId);
        return this.apiService.get(url);
    }

    LoadMedico(): void {
        this.GetActiveDoctorsDropdown()
            .subscribe(res => {
                this.Medico = res;
            });
    }

    GetLeftPanelDoctorList(status: string, searchName: string, orderby: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getDoctorList}`;
        url += '?status=' + status + '&name=' + searchName + '&orderby=' + orderby + '';
        return this.apiService.get(url);
    }
    GetDoctorDetailsByDoctorId(id: number): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getDoctorDetailsbyDoctorId}`;
        url += '?id=' + id + '';
        return this.apiService.get(url);
    }

    UpdateDoctorStatus(doctor: any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.updateDoctorStatus}`;
        return this.apiService.put(url, doctor);
    }

    GetServicesByDoctor(doctorId: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getSmeByDoctor}`;
        url = url.replace('{doctorId}', doctorId);
        return this.apiService.get(url);
    }

    public saveDoctorSmi(doctorSmi: DoctorSmi): Observable<any> {
        let url = `${API.DoctorManagement.saveDoctorSmi}`;
        return this.apiService.post(url, doctorSmi, true);
    }

    public updateDoctorSmi(doctorSmi: DoctorSmi): Observable<any> {
        let url = `${API.DoctorManagement.updateDoctorSmi}`;
        return this.apiService.put(url, doctorSmi, true);
    }

    public deleteDoctorSmi(smiId: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.deleteDoctorSmi}`;
        url = url.replace('{smiId}', smiId);
        return this.apiService.delete(url);
    }

    public checkDoctorHaveAnyService(doctorId: number, empresaId: number): Observable<RestResponse> {
        let url = `${API.DoctorManagement.checkDoctorHaveAnyService}`;
        url = url.replace('{doctorId}', doctorId.toString());
        url = url.replace('{empresaId}', empresaId.toString());
        return this.apiService.get(url);
    }

    public AddDoctorCoordinacion(model: Coordinacion): Observable<RestResponse> {
        const url = `${API.DoctorManagement.addDoctorCoordinacion}`;
        return this.apiService.post(url, model);
    }

    public UpdateDoctorCoordinacion(model: Coordinacion): Observable<RestResponse> {
        const url = `${API.DoctorManagement.updateDoctorCoordinacion}`;
        return this.apiService.put(url, model);
    }

    public DeleteDoctorCoordinacion(id: number): Observable<RestResponse> {
        const url = `${API.DoctorManagement.deleteDoctorCoordinacion}/${id}`;
        return this.apiService.delete(url);
    }

    GetVacationsListByDoctor(doctorId: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getVacationListByDoctor}`;
        url = url.replace('{doctorId}', doctorId);
        return this.apiService.get(url);
    }

    GetHorasBloqueadasListByDoctor(doctorId: string): Observable<RestResponse> {
    let url = `${API.DoctorManagement.getHorasBloqueadasByDoctorId}`;
    url = url.replace('{doctorId}', doctorId);
    return this.apiService.get(url);
    }

    public deleteDoctorVacations(id: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.deleteDoctorVacations}`;
        url = url.replace('{id}', id);
        return this.apiService.delete(url);
    }

    public deleteDoctorHorasBloqueadas(id: string): Observable<RestResponse> {
    let url = `${API.DoctorManagement.deleteDoctorHorasBloqueadas}`;
    url = url.replace('{id}', id);
    return this.apiService.delete(url);
    }

    public GetDoctorCoordinacionsByDoctorId(doctorId: number) {
        let url = `${API.DoctorManagement.getDoctorCoordinacionsByDoctorId}`;
        url += '?doctorId=' + doctorId + '';
        return this.apiService.get(url);
    }

    public UpdateDoctor(model: Doctor): Observable<RestResponse> {
        const url = `${API.DoctorManagement.updateDoctor}`;
        return this.apiService.put(url, model);
    }

    public GetDoctorCompanyList(): Observable<RestResponse> {
        const url = `${API.DoctorManagement.getDoctorCompanyList}`;
        return this.apiService.get(url);
    }
    //-----------------doctor expense section --------------------------
    AddMedicoExpenses(expense: any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.addMedicoExpense}`;
        return this.apiService.post(url, expense);
    }

    GetMedicoExpenses(id: any, type: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getMedicoExpenses}`;
        url = url.replace('{id}', id);
        url = url.replace('{type}', type);
        return this.apiService.get(url);
    }

    GetMedicoTotalByIdAndType(id: any, type: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getMedicoTotalByIdAndType}`;
        url = url.replace('{id}', id);
        url = url.replace('{type}', type);
        return this.apiService.get(url);
    }

    GetCompanyListForMedicoById(id: any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getCompanyListForMedicoById}`;
        url = url.replace('{id}', id);
        return this.apiService.get(url);
    }

    GetMedicoExpensesById(id: any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getMedicoExpenses}`;
        url = url.replace('{id}', id);
        return this.apiService.get(url);
    }

    UpdateMedicoExpenses(expense: any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.updateMedicoExpense}`;
        return this.apiService.put(url, expense);
    }

    DeleteMedicoExpense(id: any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.deleteMedicoExpense}`;
        url = url.replace('{id}', id);
        return this.apiService.delete(url);
    }

    //-----------------doctor expense section end--------------------------


    //-----------------doctor debt section --------------------------

    public getInitialDates(): Observable<RestResponse> {
        const url = `${API.Gastos.getInitialDate}`;
        return this.apiService.get(url);
    }

    GetAllDebtByMedicoId(id: any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getAllDebtByMedicoId}`;
        url = url.replace('{id}', id);
        return this.apiService.get(url);
    }

    GetNextOrPreviousMonthDebt(id: any, year: any, month: any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getNextOrPreviousMonthDebt}`;
        url = url.replace('{id}', id);
        url = url.replace('{year}', year);
        url = url.replace('{month}', month);
        return this.apiService.get(url);
    }

    AddDebt(debt: any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.addDebt}`;
        return this.apiService.post(url, debt);
    }

    UpdateDebt(debt: any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.updateDebt}`;
        return this.apiService.put(url, debt);
    }

    DeleteDebt(id: any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.deleteDebt}`;
        url = url.replace('{id}', id);
        return this.apiService.delete(url);
    }

    GenerateDebtReport(id: number): Observable<RestResponse> {
        const url = (API.DoctorManagement.generateDebtReport as string)
            .replace('{id}', id.toString());
        return this.apiService.get(url);
    }




    //-----------------doctor debt section end--------------------------

    GetVacationSmeList(id: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.vacacionesSmeListByDoctorId}`;
        url = url.replace('{id}', id);
        return this.apiService.get(url);
    }

    GetVacationSmeDropdown(id: string): Observable<any> {
        return this.GetVacationSmeList(id)
            .pipe(map(resp => {
                return resp.result.map(element => {
                    return { value: element.value, viewValue: element.viewValue };
                });
            }));
    }

    public saveDoctorVacations(vacation: DoctorVacations): Observable<any> {
        let url = `${API.DoctorManagement.saveVacaciones}`;
        return this.apiService.post(url, vacation, true);
    }

    public updateDoctorVacations(vacation: DoctorVacations): Observable<any> {
        let url = `${API.DoctorManagement.updateDoctorVacaciones}`;
        return this.apiService.put(url, vacation, true);
    }

    public AddDoctor(model: Doctor): Observable<RestResponse> {
        const url = `${API.DoctorManagement.addDoctor}`;
        return this.apiService.post(url, model);
    }

    GetExtraPeriodListByDoctorId(doctorId: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getExtraPeriodListByDoctorId}`;
        url = url.replace('{doctorId}', doctorId);
        return this.apiService.get(url);
    }

    public deleteDoctorExtraPeriod(id: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.deleteDoctorExtraPeriod}`;
        url = url.replace('{id}', id);
        return this.apiService.delete(url);
    }

    public saveExtraPeriod(extraPeriod: ExtraPeriod): Observable<any> {
        let url = `${API.DoctorManagement.saveExtraPeriod}`;
        return this.apiService.post(url, extraPeriod, true);
    }

    public saveHorasBloqueadas(extraPeriod: ExtraPeriod): Observable<any> {
    let url = `${API.DoctorManagement.saveHorasBloqueadas}`;
    return this.apiService.post(url, extraPeriod, true);
    }

    public updateHorasBloqueadas(extraPeriod: ExtraPeriod): Observable<any> {
    let url = `${API.DoctorManagement.updateHorasBloqueadas}`;
    return this.apiService.put(url, extraPeriod, true);
    }

    public updateDoctorExtraPeriod(extraPeriod: ExtraPeriod): Observable<any> {
        let url = `${API.DoctorManagement.updateDoctorExtraPeriod}`;
        return this.apiService.put(url, extraPeriod, true);
    }

    public CheckForDeleteDoctor(model: Doctor): Observable<RestResponse> {
        const url = `${API.DoctorManagement.checkForDeleteDoctor}`;
        return this.apiService.post(url, model);
    }

    public DeleteDoctor(id: number): Observable<RestResponse> {
        const url = `${API.DoctorManagement.deleteDoctor}/${id}`;
        return this.apiService.delete(url);
    }

    public GetDoctorConsultaByDoctorId(doctorId: number) {
        let url = `${API.DoctorManagement.getDoctorConsultaByDoctorId}`;
        url += '?doctorId=' + doctorId + '';
        return this.apiService.get(url);
    }

    public saveDoctorDefaultConsulta(doctor: Doctor): Observable<any> {
        let url = `${API.DoctorManagement.saveDoctorDefaultConsulta}`;
        return this.apiService.post(url, doctor, true);
    }

    public saveDoctorConsulta(doctorConsulta: DoctorConsulta): Observable<any> {
        let url = `${API.DoctorManagement.saveDoctorConsulta}`;
        return this.apiService.post(url, doctorConsulta, true);
    }

    public deleteDoctorConsulta(id: number): Observable<RestResponse> {
        const url = `${API.DoctorManagement.deleteDoctorConsulta}/${id}`;
        return this.apiService.delete(url);
    }

    public GetDoctorListExcelFile(status: string, searchName: string, orderby: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getDoctorListExcelFile}`;
        url += '?status=' + status + '&name=' + searchName + '&orderby=' + orderby + '';
        return this.apiService.get(url);
    }

    public GetDoctorTarifasByDoctorId(doctorId: number) {
        let url = `${API.DoctorManagement.getDoctorTarifasByDoctorId}`;
        url += '?doctorId=' + doctorId + '';
        return this.apiService.get(url);
    }

    public DeleteDoctorTarifa(id: number): Observable<RestResponse> {
        const url = `${API.DoctorManagement.deleteDoctorTarifa}/${id}`;
        return this.apiService.delete(url);
    }

    public SaveDoctorTarifa(doctorTarifa: DoctorTarifa): Observable<any> {
        let url = `${API.DoctorManagement.saveDoctorTarifa}`;
        return this.apiService.post(url, doctorTarifa, true);
    }

    public DownloadExcelTarifa(doctorTarifa: DoctorTarifa): Observable<any> {
        let url = `${API.DoctorManagement.downloadExcelTarifa}`;
        return this.apiService.post(url, doctorTarifa, true);
    }

    public GetDoctorDocumentationByDoctorId(doctorId: number) {
        let url = `${API.DoctorManagement.getDoctorDocumentationByDoctorId}`;
        url += '?doctorId=' + doctorId + '';
        return this.apiService.get(url);
    }

    public GetTipoDocMedicoList(): Observable<RestResponse> {
        const url = `${API.DoctorManagement.getTipoDocMedicoList}`;
        return this.apiService.get(url);
    }

    public AddDoctorDocument(model: DocMedico): Observable<RestResponse> {
        const url = `${API.DoctorManagement.addDoctorDocument}`;
        return this.apiService.post(url, model);
    }

    public DeleteDoctorDocument(id: number): Observable<RestResponse> {
        const url = `${API.DoctorManagement.deleteDoctorDocument}/${id}`;
        return this.apiService.delete(url);
    }

    public GetDocMedicoDocumentByDocumentId(id: number): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getDocMedicoDocumentByDocumentId}`;
        url += '?Id=' + id + '';
        return this.apiService.get(url);
    }

    public saveDoctorShedule(schedule: Doctorschedule): Observable<any> {
        let url = `${API.DoctorManagement.saveDoctorShedule}`;
        return this.apiService.post(url, schedule, true);
    }

    public GetSmeByIdEdit(id: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.GetSmeByIdEdit}`;
        url = url.replace('{id}', id);
        return this.apiService.get(url);
    }

    getCalendarioMedicoByMedicoId(doctorId: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getCalendarioMedicoByMedicoId}`;
        url = url.replace('{id}', doctorId);
        return this.apiService.get(url);
    }
    getCalendarioMedicoByMedicoIdWithCompanyExcel(doctorId: string,colorList:any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getCalendarioMedicoByMedicoIdWithCompanyExcel}`;
        url = url.replace('{id}', doctorId);
        return this.apiService.post(url,colorList);
    }

    getCalendarioMedicoByMedicoIdWithCompany(doctorId: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getCalendarioMedicoByMedicoIdWithCompany}`;
        url = url.replace('{id}', doctorId);
        return this.apiService.get(url);
    }

    public deleteCalendarEvent(id: string): Observable<RestResponse> {
        let url = `${API.DoctorManagement.deleteCalendarEvent}`;
        url = url.replace('{id}', id);
        return this.apiService.delete(url);
    }


    //#region doctor agenda

    public addDoctorAgenda(model: AgendaMed): Observable<RestResponse> {
        const url = `${API.DoctorManagement.addDoctorAgenda}`;
        return this.apiService.post(url, model);
    }

    public updateDoctorAgenda(model: AgendaMed): Observable<RestResponse> {
        const url = `${API.DoctorManagement.updateDoctorAgenda}`;
        return this.apiService.put(url, model);
    }

    public deleteDoctorAgenda(agendaId: number): Observable<RestResponse> {
        let url = `${API.DoctorManagement.deleteDoctorAgenda}`;
        url = url.replace('{agendaId}', String(agendaId));
        return this.apiService.delete(url);
    }

    getDoctorAgendaListByDoctorId(id: number): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getDoctorAgendaListByDoctorId}`;
        url += '?doctorId=' + id + '';
        return this.apiService.get(url);
    }

    public generateDoctorAgendaReport(model: DoctorAgendaReport): Observable<RestResponse> {
        const url = `${API.DoctorManagement.generateDoctorAgendaReport}`;
        return this.apiService.post(url, model);
    }

    //#endregion

    getDiasCierre(consultaId: number): Observable<RestResponse> {
        let url = `${API.DoctorManagement.getDiasCierre}`;
        url = url.replace('{consultaId}', consultaId.toString());
        return this.apiService.get(url);
    }

    createDiaCierre(consultaId: number, model: any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.createDiaCierre}`;
        url = url.replace('{consultaId}', consultaId.toString());
        return this.apiService.post(url, model, true);
    }

    updateDiaCierre(consultaId: number, model: any): Observable<RestResponse> {
        let url = `${API.DoctorManagement.updateDiaCierre}`;
        url = url.replace('{consultaId}', consultaId.toString());
        return this.apiService.put(url, model, true);
    }

    deleteDiaCierre(consultaId: number, id: number): Observable<RestResponse> {
        let url = `${API.DoctorManagement.deleteDiaCierre}`;
        url = url.replace('{id}', id.toString()).replace('{consultaId}', consultaId.toString());
        return this.apiService.delete(url);
    }

    GetPrincipalDoctorDropdownFromDoctorList(): Observable<any> {
        return this.GetLeftPanelDoctorList('S', '', 'Nombre')
            .pipe(map(resp => {
                return (resp.result || []).map(element => {
                    return {
                        value: element.medicoId,
                        viewValue: element.nombre
                    };
                });
            }));
    }
}
